import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme.ts';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import NavigatorSync from './components/NavigatorSync.tsx';
import { useAuth } from './contexts/AuthContext.tsx';
import AppRoutes from './routes.tsx';
import AppToastProvider from './shared/ui/AppToastProvider.tsx';
import TopBar from './components/TopBar.tsx';
import SidebarLayout from './components/Layout/SidebarLayout.tsx';
import { TenantProvider } from './components/ContextTenant.tsx';



const App: React.FC = () => {

  const { isAuthenticated, loading, user } = useAuth();
  const auth = !loading && isAuthenticated() && user?.internalUser === true;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TenantProvider>
          <AppToastProvider>
          <NavigatorSync />
          {auth && <TopBar />}
          {auth ? (
            <SidebarLayout>
              <AppRoutes />
            </SidebarLayout>
          ) : (
            <AppRoutes />
          )}
          </AppToastProvider>
        </TenantProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App; 
